// @flow
import Cookies from "js-cookie";
import type { Action } from "../../../../server/types";
import constants from "../constants";
import validDates from "../../shared/utils/validDates";

export default function selectDates({
  startDate, endDate, numNights,
}: {
  startDate: string,
  endDate: string,
  numNights: number,
}): Action {
  if (startDate && endDate && !validDates(startDate, endDate)) {
    Cookies.remove("availability");

    return {
      type: constants.AVAILABILITY_ERROR,
      data: {
        startDate, endDate, message: "Invalid dates",
      },
    };
  } else if (!startDate && !endDate) {
    Cookies.remove("availability");
  }

  Cookies.set("availability", {
    startDate,
    endDate,
    numNights,
  });

  return {
    type: constants.SELECT_DATES,
    data: {
      startDate, endDate, numNights,
    },
  };
}



// WEBPACK FOOTER //
// ./assets/shared/actions/selectDates.js